import ActionButton from '../../../docs/contracts/components/ActionButton.component.json' with { type: 'json' };
import Agenda from '../../../docs/contracts/components/Agenda.component.json' with { type: 'json' };
import Badge from '../../../docs/contracts/components/Badge.component.json' with { type: 'json' };
import Button from '../../../docs/contracts/components/Button.component.json' with { type: 'json' };
import Card from '../../../docs/contracts/components/Card.component.json' with { type: 'json' };
import CardList from '../../../docs/contracts/components/CardList.component.json' with { type: 'json' };
import Checkbox from '../../../docs/contracts/components/Checkbox.component.json' with { type: 'json' };
import Collection from '../../../docs/contracts/components/Collection.component.json' with { type: 'json' };
import Container from '../../../docs/contracts/components/Container.component.json' with { type: 'json' };
import CounterChip from '../../../docs/contracts/components/CounterChip.component.json' with { type: 'json' };
import Dashboard from '../../../docs/contracts/components/Dashboard.component.json' with { type: 'json' };
import DatePicker from '../../../docs/contracts/components/DatePicker.component.json' with { type: 'json' };
import Detail from '../../../docs/contracts/components/Detail.component.json' with { type: 'json' };
import Divider from '../../../docs/contracts/components/Divider.component.json' with { type: 'json' };
import Drawer from '../../../docs/contracts/components/Drawer.component.json' with { type: 'json' };
import Form from '../../../docs/contracts/components/Form.component.json' with { type: 'json' };
import FormImage from '../../../docs/contracts/components/FormImage.component.json' with { type: 'json' };
import FormSummary from '../../../docs/contracts/components/FormSummary.component.json' with { type: 'json' };
import Grid from '../../../docs/contracts/components/Grid.component.json' with { type: 'json' };
import Heading from '../../../docs/contracts/components/Heading.component.json' with { type: 'json' };
import Icon from '../../../docs/contracts/components/Icon.component.json' with { type: 'json' };
import Image from '../../../docs/contracts/components/Image.component.json' with { type: 'json' };
import Input from '../../../docs/contracts/components/Input.component.json' with { type: 'json' };
import Kanban from '../../../docs/contracts/components/Kanban.component.json' with { type: 'json' };
import Modal from '../../../docs/contracts/components/Modal.component.json' with { type: 'json' };
import NumberInput from '../../../docs/contracts/components/NumberInput.component.json' with { type: 'json' };
import ObjectBanner from '../../../docs/contracts/components/ObjectBanner.component.json' with { type: 'json' };
import Select from '../../../docs/contracts/components/Select.component.json' with { type: 'json' };
import Stack from '../../../docs/contracts/components/Stack.component.json' with { type: 'json' };
import Table from '../../../docs/contracts/components/Table.component.json' with { type: 'json' };
import Tabs from '../../../docs/contracts/components/Tabs.component.json' with { type: 'json' };
import Text from '../../../docs/contracts/components/Text.component.json' with { type: 'json' };
import Timeline from '../../../docs/contracts/components/Timeline.component.json' with { type: 'json' };
import WeekGrid from '../../../docs/contracts/components/WeekGrid.component.json' with { type: 'json' };
/** Registre des composants Core (ADR-099) : nom → manifeste component-manifest 1.2. */
export const coreComponents = {
    ActionButton: ActionButton,
    Agenda: Agenda,
    Badge: Badge,
    Button: Button,
    Card: Card,
    CardList: CardList,
    Checkbox: Checkbox,
    Collection: Collection,
    Container: Container,
    CounterChip: CounterChip,
    Dashboard: Dashboard,
    DatePicker: DatePicker,
    Detail: Detail,
    Divider: Divider,
    Drawer: Drawer,
    Form: Form,
    FormImage: FormImage,
    FormSummary: FormSummary,
    Grid: Grid,
    Heading: Heading,
    Icon: Icon,
    Image: Image,
    Input: Input,
    Kanban: Kanban,
    Modal: Modal,
    NumberInput: NumberInput,
    ObjectBanner: ObjectBanner,
    Select: Select,
    Stack: Stack,
    Table: Table,
    Tabs: Tabs,
    Text: Text,
    Timeline: Timeline,
    WeekGrid: WeekGrid,
};
//# sourceMappingURL=components.js.map